/**
 * Collection cards: Liquid sale + compare-at + localStorage cache only.
 * NEVER touches the shopper cart.
 */
(function() {
  if (window.__cmgpDiscountPricesLoaded) return;
  window.__cmgpDiscountPricesLoaded = true;

  var CARD_SELECTOR = '.cmgp-product-card, .prp-product-card';

  function getCache() {
    return window.cmgpSafeCartPreview || null;
  }

  function getPriceBox(card) {
    return card.querySelector('[data-cmgp-price-wrap], .cmgp-product-price, .prp-product-price');
  }

  function getBadgesWrap(card) {
    return card.querySelector('.cmgp-product-badges, .prp-product-badges');
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function applySaleBadge(card, compareCents, saleCents, source, liquidPct) {
    if (!compareCents || compareCents <= saleCents) return;
    var box = getPriceBox(card);
    var metafieldPct = liquidPct || (box && Number(box.getAttribute('data-cmgp-liquid-pct') || 0)) || 0;
    var pct = metafieldPct > 0 ? metafieldPct : Math.round((compareCents - saleCents) / compareCents * 100);
    if (pct < 1) return;
    var badges = getBadgesWrap(card);
    if (!badges) return;
    var newBadge = badges.querySelector('.cmgp-badge-new, .prp-badge-new');
    if (newBadge) newBadge.remove();
    var saleBadge = badges.querySelector('[data-cmgp-sale-badge]');
    if (!saleBadge) return;
    saleBadge.textContent = pct + '% OFF';
    saleBadge.setAttribute('data-cmgp-discount-pct', String(pct));
    if (source) saleBadge.setAttribute('data-cmgp-sale-source', source);
    saleBadge.removeAttribute('hidden');
    saleBadge.style.display = '';
  }

  function applySalePrice(card, compareCents, saleCents, source) {
    var box = getPriceBox(card);
    if (!box || !compareCents || compareCents <= saleCents) return;
    box.setAttribute('data-on-sale', 'true');
    if (source) box.setAttribute('data-cmgp-sale-source', source);
    box.removeAttribute('data-cmgp-await-cart');
    box.setAttribute('data-sale-cents', String(saleCents));
    box.setAttribute('data-compare-cents', String(compareCents));
    box.classList.add('cmgp-product-price--on-sale');
    var compareEl = box.querySelector('[data-cmgp-compare-price]');
    var saleEl = box.querySelector('[data-cmgp-sale-price]');
    if (compareEl) {
      compareEl.textContent = formatMoney(compareCents);
      compareEl.removeAttribute('hidden');
    } else {
      var span = document.createElement('span');
      span.className = 'cmgp-price-compare';
      span.setAttribute('data-cmgp-compare-price', '');
      span.textContent = formatMoney(compareCents);
      box.insertBefore(span, box.firstChild);
    }
    if (saleEl) {
      saleEl.textContent = formatMoney(saleCents);
      saleEl.classList.add('cmgp-price-sale');
    }
    applySaleBadge(card, compareCents, saleCents, source);
    card.dataset.cmgpDiscountDone = '1';
  }

  function getVariantIdFromCard(card) {
    var box = getPriceBox(card);
    if (box) {
      var id = Number(box.getAttribute('data-variant-id'));
      if (id) return id;
    }
    var dataEl = card.querySelector('[data-cmgp-variant-prices]');
    if (dataEl) {
      try {
        var list = JSON.parse(dataEl.getAttribute('data-cmgp-variant-prices') || '[]');
        if (list && list.length) return list[0].id;
      } catch (e) {}
    }
    return null;
  }

  function getVariantListFromCard(card) {
    var dataEl = card.querySelector('[data-cmgp-variant-prices]');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.getAttribute('data-cmgp-variant-prices') || '[]');
    } catch (e) {
      return [];
    }
  }

  function applyCompareAtFromVariantData(card) {
    var box = getPriceBox(card);
    if (!box || box.getAttribute('data-on-sale') === 'true') return false;

    var list = getVariantListFromCard(card);
    if (!list.length) return false;

    var variantId = Number(box.getAttribute('data-variant-id'));
    var selected = null;
    var bestSale = null;

    for (var i = 0; i < list.length; i++) {
      var entry = list[i];
      if (variantId && Number(entry.id) === variantId) selected = entry;
      if (entry.c > entry.p) {
        if (!bestSale || entry.p < bestSale.p) bestSale = entry;
      }
    }

    if (selected && selected.c > selected.p) {
      applySalePrice(card, selected.c, selected.p, 'compare-at');
      return true;
    }

    if (bestSale) {
      applySalePrice(card, bestSale.c, bestSale.p, 'compare-at');
      return true;
    }

    return false;
  }

  function syncSaleFromDOM(card) {
    var box = getPriceBox(card);
    if (!box || box.getAttribute('data-on-sale') !== 'true') return false;
    var compareCents = Number(box.getAttribute('data-compare-cents') || 0);
    var saleCents = Number(box.getAttribute('data-sale-cents') || 0);
    if (!compareCents || !saleCents || compareCents <= saleCents) return false;
    var source = box.getAttribute('data-cmgp-sale-source') || 'liquid';
    var liquidPct = Number(box.getAttribute('data-cmgp-liquid-pct') || 0);
    applySaleBadge(card, compareCents, saleCents, source, liquidPct);
    card.dataset.cmgpDiscountDone = '1';
    return true;
  }

  function applyCacheToCard(card) {
    if (card.dataset.cmgpDiscountDone === '1') return;

    if (syncSaleFromDOM(card)) return;

    var box = getPriceBox(card);
    if (box && box.getAttribute('data-on-sale') === 'true') {
      card.dataset.cmgpDiscountDone = '1';
      return;
    }

    if (applyCompareAtFromVariantData(card)) return;

    var cache = getCache();
    var variantId = getVariantIdFromCard(card);
    if (cache && variantId) {
      var cached = cache.getCached(variantId);
      if (cached && cached.onSale) {
        applySalePrice(card, cached.original, cached.final, 'cache');
        return;
      }
    }

    card.dataset.cmgpDiscountDone = '1';
  }

  function getProductCards(root) {
    root = root || document;
    if (root.nodeType === 1 && root.matches && root.matches(CARD_SELECTOR)) {
      return [root];
    }
    return Array.prototype.slice.call(root.querySelectorAll(CARD_SELECTOR));
  }

  function scanCollectionPrices(root) {
    getProductCards(root || document).forEach(applyCacheToCard);
  }

  function observeDynamicGrids() {
    var selectors = '.cmgp-grid, .cmgp-replaceable-content, .prp-products-container, product-recommendations';
    document.querySelectorAll(selectors).forEach(function(grid) {
      if (grid.__cmgpDiscountObs) return;
      grid.__cmgpDiscountObs = true;
      new MutationObserver(function() {
        scanCollectionPrices(grid);
      }).observe(grid, { childList: true, subtree: true });
    });
  }

  function boot() {
    scanCollectionPrices(document);
    observeDynamicGrids();
    document.addEventListener('cmgp-content-replaced', function() {
      scanCollectionPrices(document);
    });
    document.addEventListener('recommendations:loaded', function() {
      scanCollectionPrices(document);
    });
    document.addEventListener('shopify:section:load', function() {
      scanCollectionPrices(document);
    });
  }

  window.initCmgpCollectionDiscountPrices = function(root) {
    scanCollectionPrices(root || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
